import {GALinkStatus} from '../../../util/uiconstants';

export const mapComponent = ({
	gaComponentId: id,
	shortName,
	gaScopeName,
	gaScopeId: scopeId,
	isSubScope,
	gaRoleTypeId,
	pocText,
	pocEmail: pointOfContact,
	pocgui: pocGui,
	parentComponentId: gaParentComponentId,
	gaLinkStatusId: linkRequest,
	concurrencyToken,
	scopeInstructionsCount,
	componentInstructionsCount,
	gaScopeTypeId,
	scopePublishDate,
	teamPublishDate,
	teamName,
	relatedDocuments,
	snapshotId,
	sentStatusId,
	scopeMissingDueDatesCount,
	componentMissingDueDatesCount,
	sentScopeSnapshotId,
	sentComponentSnapshotId,
	componentSnapshotId,
	hasInstructionVersion,
	isDeleted,
	gaComponentGUID,
	isCopiedComponent
}) => ({
	id,
	name: shortName || teamName,
	scope: gaScopeName || '-',
	scopeId,
	isSubScope,
	role: gaRoleTypeId || '-',
	pocText,
	pointOfContact,
	pocGui,
	gaParentComponentId,
	gaComponentId: id,
	linkRequest,
	concurrencyToken,
	gaScopeTypeId,
	relatedDocuments: normalizeRelDocuments(relatedDocuments) || [],
	instructionCount: scopeInstructionsCount + componentInstructionsCount,
	scopePublishDate,
	teamPublishDate,
	snapshotId: snapshotId ?? 0,
	sentStatusId: sentStatusId ?? 0,
	scopeMissingDueDatesCount: scopeMissingDueDatesCount ?? 0,
	componentMissingDueDatesCount: componentMissingDueDatesCount ?? 0,
	sentScopeSnapshotId: sentScopeSnapshotId ?? 0,
	sentComponentSnapshotId: sentComponentSnapshotId ?? 0,
	componentSnapshotId: componentSnapshotId ?? 0,
	hasInstructionVersion,
	isDeleted,
	gaComponentGUID,
	isCopiedComponent
});

const normalizeRelDocuments = (relDocuments) => {
	return relDocuments?.map((document) => {
		return normalizeDocument(document);
	});
};

export const normalizeDocument = (document) => {
	return {
		engagementId: document.engagementId,
		id: document.id,
		documentName: document.documentName,
		documentTypeId: document.documentTypeId,
		documentChangeTypeId: document.documentChangeTypeId,
		documentEditUserName: document.documentEditUserName,
		documentEditUserCreateDate: document.documentEditUserCreateDate,
		confidentialityTypeId: document.confidentialityTypeId,
		fileExt: document.fileExt,
		fileSizeKB: document.fileSizeKB,
		hasComments: document.hasComments,
		hasHiddenSheets: document.hasHiddenSheets,
		hasHighlights: document.hasHighlights,
		hasAnySystemAssociated: document.hasAnySystemAssociated,
		isConflicted: document.isConflicted,
		isShared: document.isShared,
		isEPSignoffRequired: document.isEPSignoffRequired,
		isEQRSignoffRequired: document.isEQRSignoffRequired,
		isEPSignoffUserRequired: document.isEPSignoffUserRequired,
		isEQRSignoffUserRequired: document.isEQRSignoffUserRequired,
		lastModifiedFullName: document.lastModifiedFullName,
		modifiedDate: document.modifiedDate,
		smartEvidenceSourceId: document.smartEvidenceSourceId,
		trackChange: document.trackChange,
		approvals: document.approvals

		//TODO: Implement in US 1132819
		// isReadOnly
		// isDragAndDrop
		// isReturned
	};
};

export default (components) => components?.map(mapComponent);
